
import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import toster from 'common/utils/toast';

const SectionTextComponent = ({
   text,
   className,
   isEditable,
   style,
   limit,
   name,
   onChange,
}) => {
   const inputRef = useRef(null);
   const [inputFocus, setInputFocus] = useState(false)

   useEffect(() => {
      if(isEditable && inputRef.current && !inputFocus){
         inputRef.current.style.height = 'auto';
         inputRef.current.innerText = text
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [isEditable, text])
   const  setEndOfContenteditable = (contentEditableElement) => {
      let range = null;
      let selection = null;
      if(document.createRange) {
         range = document.createRange();
         range.selectNodeContents(contentEditableElement);
         range.collapse(false);
         selection = window.getSelection();
         selection.removeAllRanges();
         selection.addRange(range);
      } else if(document.selection) {
         range = document.body.createTextRange();
         range.moveToElementText(contentEditableElement);
         range.collapse(false);
         range.select();
      }
   }
   if(!isEditable){
      return (
         <span
            style={ style }
            className={ `${ className } ql-editor` }
            dangerouslySetInnerHTML={ {
               __html: text,
            } }
         />

      )
   }

   return (
      <div
         style={ style }
         role='presentation'
         contentEditable
         ref={ inputRef }
         suppressContentEditableWarning
         className={ `${ className }` }
         onPaste={ (e) => {
            let clipboardData, pastedData;
            const text = inputRef.current?.innerText?.trim() || '';
            e.stopPropagation();
            e.preventDefault();
            clipboardData = e.clipboardData || window.clipboardData;
            pastedData = clipboardData.getData('Text');
            if(inputRef?.current) {
               if(text.length + pastedData?.length > limit) {
                  toster.error(`${ limit } character limit reached`,  { toastId: `${ name }_limit_reached` })
                  pastedData = pastedData.slice(0, limit - text.length)
               }
            }
            window.document.execCommand('insertText', false, pastedData);
         } }
         onInput={ (e) => {
            if(inputRef.current){
               const text = inputRef.current?.innerText?.trim() || '';
               if(text.length > limit){
                  e.preventDefault();
                  toster.error(`${ limit } character limit reached`,  { toastId: `${ name }_limit_reached` })
                  inputRef.current.innerText = text.substring(0, limit);
                  setEndOfContenteditable(inputRef.current);
                  return
               }
               if(onChange){
                  onChange(name, text)
               }
            }
         } }
         onFocus={ () => setInputFocus(true) }
         onBlur={ () => setInputFocus(false) }
      >
      </div>

   );
}
SectionTextComponent.propTypes = {
   text: PropTypes.string,
   className: PropTypes.string,
   isEditable: PropTypes.bool,
   style: PropTypes.object,
   onChange: PropTypes.func,
   name: PropTypes.string,
   limit: PropTypes.number,
};
SectionTextComponent.defaultProps = {
   text: '',
   className: '',
   style: {},
}
export default SectionTextComponent;


